export default __webpack_public_path__ + "static/media/user_1.52d63597.svg";